import React, { useState } from 'react';
import { Button, Input } from '../../components';
import { forgotPassword, verifyPwOrCode } from 'services';
import { connect, ConnectedProps } from 'react-redux';
import { ReduxState } from '../../../interfaces';
import { faNumToEnNum } from '../../../scripts';

interface OwnProps {
    phoneNumber?: string;
    onForgotPasswordClick: () => void;
    onEnterCodeClick: () => void;
    onComplete: (isTwoFactorEnabled?: boolean) => void;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const EnterPassword: React.FC<Props> = function (props) {
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState<boolean>(false);
    const [forgotPasswordLoading, setForgotPasswordLoading] = useState<boolean>(false);

    const handleSubmit = () => {
        const onComplete = (e: boolean) => {
            props.onComplete(e);
        };

        verifyPwOrCode(setLoading, { phoneNumber: props.phoneNumber, password }, onComplete);
    };

    const onForgotPasswordClick = () => {
        forgotPassword(setForgotPasswordLoading, { phoneNumber: props.phoneNumber }, props.onForgotPasswordClick);
    };

    return (
        <div className={'flex flex-col w-full'}>
            <p className={'text-base text-darkPurple-100 mt-6 font-light max-lg:text-sm'}>
                رمز عبور خود را جهت ورود به پنل کاربری وارد کنید.
            </p>
            <label className={'text-base mt-4 font-light max-lg:text-sm'}>رمز عبور:</label>
            <Input
                type={'password'}
                dir={password ? 'ltr' : 'rtl'}
                className={'mt-2'}
                placeholder={'رمز عبور خود را وارد کنید'}
                value={password}
                onChange={(e) => setPassword(faNumToEnNum(e.target.value))}
                onPressEnter={handleSubmit}
            />
            <Button
                className={'mt-6'}
                type={'primary'}
                onClick={handleSubmit}
                loading={loading}
                disabled={loading || !password}
            >
                ورود
            </Button>
            <Button className={'bg-white text-primary-100 mt-2'} type={'text'} onClick={props.onEnterCodeClick}>
                ورود با کد یکبار مصرف
            </Button>
            <Button
                className={'bg-white text-primary-100 mt-2'}
                type={'text'}
                loading={forgotPasswordLoading}
                disabled={forgotPasswordLoading}
                onClick={onForgotPasswordClick}
            >
                فراموشی رمز عبور
            </Button>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(EnterPassword);
